/* ELIO Intelligence Ledger v1.2 — full relay + session exit
   Add to theme.liquid immediately before </body>:
   {{ 'elio-intelligence-ledger.js' | asset_url | script_tag }}

   This collector never changes merchandising or checkout behavior. It publishes
   first-party behavioral facts into Shopify Analytics. The ELIO custom pixel
   enriches them with Shopify client_id and transports them to Vercel/Ops.
*/
(function () {
  'use strict';

  if (window.__ELIO_INTELLIGENCE_LEDGER_V1__) return;
  window.__ELIO_INTELLIGENCE_LEDGER_V1__ = true;

  var EVENT_NAME = 'elio:intelligence_event';
  var MODEL_ENDPOINT = 'https://elio-intelligence-relay-j1ny.vercel.app/api/model';
  var BEHAVIOR_ENDPOINT = 'https://elio-intelligence-relay-j1ny.vercel.app/api/behavior';
  var VISITOR_KEY = 'elio_intelligence_visitor_v1';
  var SESSION_KEY = 'elio_intelligence_session_v1';
  var SESSION_GAP_MS = 30 * 60 * 1000;
  var lastCheckoutIntentAt = 0;
  var HEARTBEATS = [15000, 30000, 60000, 120000, 300000];
  var state = null;
  var modelConfig = null;
  var lastFingerprint = '';
  var lastFingerprintAt = 0;

  function now() { return Date.now(); }
  function clean(v, max) { return String(v == null ? '' : v).trim().slice(0, max || 500); }
  function parse(raw) { try { return JSON.parse(raw); } catch (_) { return null; } }
  function id(prefix) {
    return prefix + '-' + now().toString(36) + '-' + Math.random().toString(36).slice(2, 11);
  }
  function storageGet(store, key) { try { return store.getItem(key); } catch (_) { return null; } }
  function storageSet(store, key, value) { try { store.setItem(key, value); } catch (_) {} }
  function cookie(name) {
    try {
      var parts = String(document.cookie || '').split(';');
      for (var i = 0; i < parts.length; i += 1) {
        var p = parts[i].trim();
        if (p.indexOf(name + '=') === 0) return decodeURIComponent(p.slice(name.length + 1));
      }
    } catch (_) {}
    return '';
  }
  function visitorId() {
    var existing = clean(storageGet(localStorage, VISITOR_KEY), 180);
    if (existing) return existing;
    var created = id('ev');
    storageSet(localStorage, VISITOR_KEY, created);
    return created;
  }
  function source() {
    var u;
    try { u = new URL(location.href); } catch (_) { u = null; }
    var fbclid = u ? clean(u.searchParams.get('fbclid'), 500) : '';
    var utmSource = u ? clean(u.searchParams.get('utm_source'), 100) : '';
    var utmMedium = u ? clean(u.searchParams.get('utm_medium'), 100) : '';
    var utmCampaign = u ? clean(u.searchParams.get('utm_campaign'), 200) : '';
    var utmContent = u ? clean(u.searchParams.get('utm_content'), 200) : '';
    var utmTerm = u ? clean(u.searchParams.get('utm_term'), 200) : '';
    var paidMeta = Boolean(fbclid || (/^(facebook|fb|instagram|ig|meta)$/i.test(utmSource) && /paid|cpc/i.test(utmMedium)));
    return {
      traffic_source: paidMeta ? 'meta_paid' : (utmSource || (document.referrer ? 'referral' : 'direct')),
      paid_meta: paidMeta,
      utm_source: utmSource,
      utm_medium: utmMedium,
      utm_campaign: utmCampaign,
      utm_content: utmContent,
      utm_term: utmTerm,
      fbclid: fbclid,
      referrer: clean(document.referrer, 1200),
      fbp: clean(cookie('_fbp'), 300),
      fbc: clean(cookie('_fbc'), 300)
    };
  }
  function newSession() {
    var t = now();
    return {
      schema_version: 1,
      visitor_id: visitorId(),
      session_id: id('es'),
      started_at: t,
      last_seen_at: t,
      landing_url: clean(location.href, 1500),
      landing_path: clean(location.pathname, 500),
      pageviews: 0,
      product_views: 0,
      colors_viewed: {},
      sizes_viewed: {},
      size_explicit: false,
      pair_explicit: false,
      pair_mode: 'unknown',
      units_configured: 0,
      cart_value: 0,
      cart_units: 0,
      atc_count: 0,
      cart_open_count: 0,
      checkout_intent_count: 0,
      size_guide_count: 0,
      return_visitor: Boolean(storageGet(localStorage, 'elio_intelligence_seen_v1')),
      shadow_sent: false,
      source: source()
    };
  }
  function loadSession() {
    var existing = parse(storageGet(sessionStorage, SESSION_KEY));
    var t = now();
    if (!existing || !existing.session_id || t - Number(existing.last_seen_at || 0) >= SESSION_GAP_MS) {
      existing = newSession();
    }
    existing.last_seen_at = t;
    state = existing;
    persist();
    storageSet(localStorage, 'elio_intelligence_seen_v1', String(t));
    return state;
  }
  function persist() {
    if (!state) return;
    state.last_seen_at = now();
    storageSet(sessionStorage, SESSION_KEY, JSON.stringify(state));
  }
  function elapsed() { return Math.max(0, now() - Number(state.started_at || now())); }
  function countKeys(obj) { return Object.keys(obj || {}).length; }
  function currentProduct() {
    var root = document.querySelector('[data-elio-pdp-swap], .elio-pdp');
    if (!root) return {};
    var title = document.querySelector('h1') || document.querySelector('[data-product-title]');
    var selected = root.querySelector('[data-selected-variant]');
    var variant = parse(selected ? selected.textContent : '') || {};
    var color = root.querySelector('[data-current-color]');
    var size = root.querySelector('input.elio-pdp__size-input:checked, input[name="Size"]:checked, input[name="size"]:checked');
    var pair = root.querySelector('[data-pair-mode].is-active, [data-pair-mode][aria-checked="true"]');
    return {
      product_path: clean(location.pathname, 500),
      product_title: clean(title && title.textContent, 300),
      variant_id: clean(variant.id || (root.querySelector('input[name="id"]') || {}).value, 100),
      color: clean(color && color.textContent, 100),
      size: clean(size && size.value, 40),
      pair_mode: clean(pair && pair.getAttribute('data-pair-mode'), 40),
      configured_units: Number(pair && pair.getAttribute('data-qty') || 0)
    };
  }
  function snapshot() {
    return {
      elapsed_ms: Math.round(elapsed()),
      pageviews: Number(state.pageviews || 0),
      product_views: Number(state.product_views || 0),
      colors_viewed: countKeys(state.colors_viewed),
      sizes_viewed: countKeys(state.sizes_viewed),
      size_explicit: Boolean(state.size_explicit),
      pair_explicit: Boolean(state.pair_explicit),
      pair_mode: state.pair_mode || 'unknown',
      units_configured: Number(state.units_configured || 0),
      cart_units: Number(state.cart_units || 0),
      cart_value: Number(state.cart_value || 0),
      atc_count: Number(state.atc_count || 0),
      cart_open_count: Number(state.cart_open_count || 0),
      checkout_intent_count: Number(state.checkout_intent_count || 0),
      size_guide_count: Number(state.size_guide_count || 0),
      return_visitor: Boolean(state.return_visitor)
    };
  }
  function modelFeature(name, s) {
    var m = {
      log_elapsed: Math.log1p(Number(s.elapsed_ms || 0) / 1000),
      pageviews: Number(s.pageviews || 0), product_views: Number(s.product_views || 0),
      colors_viewed: Number(s.colors_viewed || 0), sizes_viewed: Number(s.sizes_viewed || 0),
      size_explicit: s.size_explicit ? 1 : 0, pair_explicit: s.pair_explicit ? 1 : 0,
      bundle_selected: s.pair_mode === 'cross' || Number(s.units_configured || 0) >= 2 || Number(s.cart_units || 0) >= 2 ? 1 : 0,
      units_configured: Number(s.units_configured || 0), cart_units: Number(s.cart_units || 0),
      log_cart_value: Math.log1p(Number(s.cart_value || 0) / 100), atc_count: Number(s.atc_count || 0),
      cart_open_count: Number(s.cart_open_count || 0), checkout_intent_count: Number(s.checkout_intent_count || 0),
      size_guide_count: Number(s.size_guide_count || 0), return_visitor: s.return_visitor ? 1 : 0
    };
    return Number(m[name] || 0);
  }
  function scoreModel(s) {
    var m = modelConfig && modelConfig.model;
    if (!m || !Array.isArray(m.features)) return null;
    var z = Number(m.intercept || 0);
    m.features.forEach(function (f) {
      var sd = Number(m.stds && m.stds[f] || 1) || 1;
      z += Number(m.weights && m.weights[f] || 0) * ((modelFeature(f, s) - Number(m.means && m.means[f] || 0)) / sd);
    });
    if (z > 35) return 1;
    if (z < -35) return 0;
    return 1 / (1 + Math.exp(-z));
  }
  function maybeModelShadow(reason) {
    if (!modelConfig || modelConfig.mode !== 'shadow' || state.model_shadow_sent) return;
    var score = scoreModel(snapshot());
    var threshold = Number(modelConfig.model && modelConfig.model.threshold);
    if (score == null || !Number.isFinite(threshold) || score < threshold) return;
    state.model_shadow_sent = true;
    state.model_score = score;
    state.model_version = clean(modelConfig.model.version, 100);
    persist();
    publish('model_shadow', { reason: reason || 'threshold', score: score, threshold: threshold, model_version: state.model_version });
  }
  function publish(type, detail, options) {
    options = options || {};
    if (!state) loadSession();
    var payload = {
      schema_version: 1,
      event_type: clean(type, 80),
      event_id: id('ei'),
      event_time_ms: now(),
      visitor_id: state.visitor_id,
      session_id: state.session_id,
      path: clean(location.pathname, 500),
      href: clean(location.href, 1500),
      landing_url: state.landing_url,
      landing_path: state.landing_path,
      source: state.source,
      state: snapshot(),
      detail: detail || {}
    };
    var fingerprint = payload.event_type + '|' + JSON.stringify(payload.detail);
    if (!options.allowRepeat && fingerprint === lastFingerprint && now() - lastFingerprintAt < 1000) return;
    lastFingerprint = fingerprint;
    lastFingerprintAt = now();
    try {
      var result = window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish
        ? window.Shopify.analytics.publish(EVENT_NAME, payload)
        : null;
      if (result && typeof result.catch === 'function') result.catch(function () {});
    } catch (_) {}

    /*
      v1.2: transport every behavioral fact directly as well as through
      Shopify Analytics. The custom pixel adds Shopify client_id when it
      receives the same event; the relay dedupes on event_id.
    */
    directPost(payload);

    return payload;
  }
  function directPost(payload) {
    if (!payload || !/^https:\/\//i.test(BEHAVIOR_ENDPOINT)) return;
    var record = {};
    Object.keys(payload).forEach(function (key) { record[key] = payload[key]; });
    record.record_type = 'behavior_event';
    var body = JSON.stringify(record);
    try {
      if (navigator.sendBeacon) {
        var blob = new Blob([body], { type: 'text/plain;charset=UTF-8' });
        if (navigator.sendBeacon(BEHAVIOR_ENDPOINT, blob)) return;
      }
    } catch (_) {}
    try {
      fetch(BEHAVIOR_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: body,
        keepalive: true,
        credentials: 'omit'
      }).catch(function () {});
    } catch (_) {}
  }
  function maybeShadow(reason) {
    if (state.shadow_sent) return;
    var s = snapshot();
    var meaningful = s.elapsed_ms >= 30000 || s.atc_count > 0 || s.checkout_intent_count > 0;
    var commercialConfig = s.size_explicit && (s.pair_explicit || s.cart_units >= 2 || s.units_configured >= 2);
    var deep = s.atc_count > 0 || s.checkout_intent_count > 0 || (s.return_visitor && s.cart_open_count > 0);
    maybeModelShadow(reason);
    if (!(meaningful && commercialConfig && deep)) return;
    state.shadow_sent = true;
    persist();
    publish('commitment_shadow', { rule_version: 'heuristic_v1', reason: reason || 'threshold' });
  }
  function loadModel() {
    if (!/^https:\/\//i.test(MODEL_ENDPOINT) || MODEL_ENDPOINT.indexOf('REPLACE_WITH_') === 0) return;
    try {
      fetch(MODEL_ENDPOINT, { credentials: 'omit', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (json) { if (json && json.ok) { modelConfig = json; maybeModelShadow('model_loaded'); } })
        .catch(function () {});
    } catch (_) {}
  }
  function inspectPdp(reason) {
    var p = currentProduct();
    if (!p.product_path) return;
    state.product_views = Math.max(1, Number(state.product_views || 0));
    if (p.color) state.colors_viewed[p.color] = true;
    if (p.size) state.sizes_viewed[p.size] = true;
    if (p.pair_mode) state.pair_mode = p.pair_mode;
    if (p.configured_units) state.units_configured = p.configured_units;
    persist();
    publish('product_state', { reason: reason || 'inspect', product: p });
  }
  function cartCents(cart) {
    return Number(cart && (cart.total_price != null ? cart.total_price : cart.items_subtotal_price) || 0);
  }
  function applyCart(cart, reason) {
    if (!cart) return;
    state.cart_units = Number(cart.item_count || 0);
    state.cart_value = cartCents(cart);
    persist();
    publish('cart_snapshot', {
      reason: reason || 'cart',
      item_count: state.cart_units,
      value_cents: state.cart_value,
      currency: clean(window.Shopify && window.Shopify.currency && (window.Shopify.currency.active || window.Shopify.currency), 10)
    });
    maybeShadow('cart_snapshot');
  }
  function fetchCart(reason) {
    try {
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { applyCart(cart, reason); })
        .catch(function () {});
    } catch (_) {}
  }
  function isCartAdd(url) {
    try { return /\/cart\/add(?:\.js)?\/?$/.test(new URL(url, location.href).pathname); }
    catch (_) { return false; }
  }
  function hookNetwork() {
    try {
      var nativeFetch = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : input && input.url;
        var promise = nativeFetch.apply(this, arguments);
        if (isCartAdd(url)) {
          promise.then(function (r) {
            if (r && r.ok) {
              state.atc_count += 1;
              persist();
              publish('atc_success', { transport: 'fetch', product: currentProduct() });
              fetchCart('after_atc');
              maybeShadow('atc_success');
            }
          }).catch(function () {});
        }
        return promise;
      };
    } catch (_) {}
    try {
      var open = XMLHttpRequest.prototype.open;
      var send = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) {
        this.__elioIntelCartAdd = isCartAdd(url);
        return open.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function () {
        if (this.__elioIntelCartAdd) {
          this.addEventListener('load', function () {
            if (this.status >= 200 && this.status < 400) {
              state.atc_count += 1;
              persist();
              publish('atc_success', { transport: 'xhr', product: currentProduct() });
              fetchCart('after_atc');
              maybeShadow('atc_success');
            }
          }, { once: true });
        }
        return send.apply(this, arguments);
      };
    } catch (_) {}
  }
  var CHECKOUT_SELECTOR = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    'a[href*="/checkout"]',
    '[data-elio-checkout]',
    '.js-checkout-button',
    '[data-elio-nudge-decline]',
    '.elio-pc-modal__skip',
    '.elio-pc-modal__add',
    '.elio-pdp__sticky-atc.elio-flip-stack .elio-pdp__sticky-button',
    'shopify-apple-pay-button',
    'shop-pay-wallet-button',
    'shopify-google-pay-button',
    'shopify-paypal-button',
    'shopify-amazon-pay-button',
    'shopify-accelerated-checkout',
    'shopify-accelerated-checkout-cart'
  ].join(',');
  function checkoutTarget(el) {
    return el && el.closest && el.closest(CHECKOUT_SELECTOR);
  }
  function checkoutTargetFromEvent(event) {
    var path = [];
    try { path = typeof event.composedPath === 'function' ? event.composedPath() : []; } catch (_) {}
    for (var i = 0; i < path.length; i += 1) {
      var el = path[i];
      if (!el || el.nodeType !== 1 || !el.matches) continue;
      try {
        if (el.matches(CHECKOUT_SELECTOR)) return el;
        var nested = checkoutTarget(el);
        if (nested) return nested;
      } catch (_) {}
    }
    return checkoutTarget(event && event.target);
  }
  function observeCheckoutIntent(eventType, detail) {
    if (now() - lastCheckoutIntentAt <= 3000) return;
    lastCheckoutIntentAt = now();
    state.checkout_intent_count += 1;
    persist();
    var payload = publish(eventType || 'checkout_intent_observed', detail || {});
    // publish() already performs unload-safe direct transport in v1.2.
    // The Custom Pixel also forwards the same event_id with Shopify client_id.
    fetchCart('checkout_intent');
    maybeShadow('checkout_intent');
  }
  function clickHandler(event) {
    var target = event.target;
    var size = target && target.closest && target.closest('input.elio-pdp__size-input, input[name="Size"], input[name="size"], label[for]');
    if (size && size.closest('.elio-pdp__sizes, .elio-pdp__fieldset')) {
      setTimeout(function () {
        var p = currentProduct();
        state.size_explicit = true;
        if (p.size) state.sizes_viewed[p.size] = true;
        persist();
        publish('size_selected', { product: p });
        maybeShadow('size_selected');
      }, 0);
    }
    var pair = target && target.closest && target.closest('[data-pair-mode]');
    if (pair) {
      state.pair_explicit = true;
      state.pair_mode = clean(pair.getAttribute('data-pair-mode'), 40) || 'unknown';
      state.units_configured = Number(pair.getAttribute('data-qty') || (state.pair_mode === 'single' ? 1 : 2));
      persist();
      publish('pair_selected', { pair_mode: state.pair_mode, configured_units: state.units_configured });
      maybeShadow('pair_selected');
    }
    var color = target && target.closest && target.closest('[data-color-link]');
    if (color) publish('color_selected', { href: clean(color.href, 1000), label: clean(color.getAttribute('aria-label') || color.textContent, 100) });
    var guide = target && target.closest && target.closest('[data-elio-fit-finder], [data-size-guide], .elio-fit-finder, a[href*="size-guide"], button[aria-label*="size" i]');
    if (guide) {
      state.size_guide_count += 1;
      persist();
      publish('size_guide_opened', {});
    }
    var cartOpen = target && target.closest && target.closest('a[href="/cart"], [data-cart-drawer-trigger], .js-cart-drawer-trigger, button[aria-controls*="cart" i]');
    if (cartOpen) {
      state.cart_open_count += 1;
      persist();
      publish('cart_opened', {});
      fetchCart('cart_open');
      maybeShadow('cart_opened');
    }
    var checkout = checkoutTargetFromEvent(event);
    if (checkout) {
      observeCheckoutIntent('checkout_intent_observed', {
        source: clean(location.pathname, 200),
        transport: 'dom_click',
        tag_name: clean(checkout.tagName, 80),
        element_name: clean(checkout.getAttribute && checkout.getAttribute('name'), 120),
        element_href: clean(checkout.getAttribute && checkout.getAttribute('href'), 500)
      });
    }
  }

  loadSession();
  loadModel();
  state.pageviews += 1;
  if (/\/products\//.test(location.pathname)) state.product_views += 1;
  persist();
  publish('session_start', { return_visitor: state.return_visitor }, { allowRepeat: true });
  publish('page_view', { title: clean(document.title, 300) }, { allowRepeat: true });
  if (/\/products\//.test(location.pathname)) inspectPdp('initial');
  if (location.pathname === '/cart') {
    state.cart_open_count += 1;
    persist();
    fetchCart('cart_page');
  }
  document.addEventListener('click', clickHandler, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form')) return;
    var active = document.activeElement;
    var checkout = checkoutTarget(active);
    if (!checkout && form.querySelector) {
      try { checkout = form.querySelector(CHECKOUT_SELECTOR); } catch (_) {}
    }
    var action = clean(form.getAttribute && form.getAttribute('action'), 1000);
    if (!checkout && action.toLowerCase().indexOf('/checkout') === -1) return;
    observeCheckoutIntent('checkout_intent_observed', {
      source: clean(location.pathname, 200),
      transport: 'form_submit',
      form_action: action
    });
  }, true);
  document.addEventListener('change', function (event) {
    var t = event.target;
    if (t && t.matches && t.matches('input.elio-pdp__size-input, input[name="Size"], input[name="size"]')) {
      setTimeout(function () { inspectPdp('change'); }, 0);
    }
  }, true);
  document.addEventListener('elio:checkout_intent', function (event) {
    observeCheckoutIntent('checkout_intent', event.detail || {});
  });
  hookNetwork();
  HEARTBEATS.forEach(function (delay) {
    setTimeout(function () {
      persist();
      publish('session_checkpoint', { checkpoint_ms: delay }, { allowRepeat: true });
      maybeShadow('checkpoint_' + delay);
    }, delay);
  });

  /*
    Final session snapshot. This is descriptive only: dwell remains a feature,
    never a positive/negative Meta optimization event.
  */
  window.addEventListener('pagehide', function () {
    persist();
    publish('session_end', { reason: 'pagehide' }, { allowRepeat: true });
  }, true);
})();